import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Wrapper = styled.div``;

export const HeaderContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 10px;
`;

export const StepCount = styled.div`
	font-weight: 500;
	font-size: 16px;
`;

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	background-color: ${colors.white};
	padding: 10px;
`;

export const FileSelectionWrapper = styled.div`
	display: flex;
	flex-direction: row;
	gap: 10px;
	border-bottom: 1px solid ${colors.grey3};
	padding: 0 0 6px 0px;
`;

export const MappingContentWrapper = styled.div`
	display: flex;
`;

export const PreviewWrapper = styled.div`
	background-color: #ffffff;
	padding: 10px;
	margin-top: 20px;
`;

export const DataPreviewWrapper = styled.div`
	margin: 16px 0 0 0;
`;

export const ButtonContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	margin: 10px 0 0 0;
`;
